import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

const basePath = import.meta.env.PROD ? `${__CLOUDFRONT_URL__}` : '/static'

i18n.use(LanguageDetector)
    .use(Backend)
    .use(initReactI18next)
    .init({
        ns: 'common',
        defaultNS: 'common',
        fallbackLng: 'en',
        debug: import.meta.env.DEV,
        interpolation: {
            escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        },
        detection: {
            lookupCookie: 'django_language',
        },
        backend: {
            loadPath: `${basePath.replace(/\/+$/, '')}/web/locales/{{lng}}/{{ns}}.json`,
        },
        react: {
            bindI18n: 'languageChanged loaded',
            bindI18nStore: 'added removed',
        },
    })

export default i18n
